(function () {
	'use strict';

	angular.module('mx.components').component('mxTimeline', {
		bindings: {
			items: '<',
			selectedItem: '=?',
			idFieldName: '@',
			titleFieldName: '@',
			dateFieldName: '@',
			contentFieldName: '@',
			maxHeight: '<',
			minHeight: '<',
		},
		controller: MxTimelineCtrl,
		controllerAs: 'vm',
		template: '<vis-timeline ng-if="vm.dataLoaded" data="::vm.timelineData" options="::vm.options" events="::vm.events"></vis-timeline>',
	});

	MxTimelineCtrl.$inject = ['$scope', 'VisDataSet'];

	function MxTimelineCtrl($scope, VisDataSet) {
		var vm = this;
		var timelineItems;

		vm.events = {
			click: function (params) {
				if (!params.item) {
					return;
				}

				$scope.$evalAsync(function () {
					vm.selectedItem = timelineItems.filter(function (item) {
						return item[vm.idFieldName] === params.item;
					})[0];
				});
			},
		};

		vm.$onInit = function () {
			vm.maxHeight = parseInt(vm.maxHeight); // to support old-templates with legacy string-type attribute from SB
			vm.minHeight = parseInt(vm.minHeight); // to support old-templates with legacy string-type attribute from SB
			vm.options = {
				maxHeight: isNaN(vm.maxHeight) ? undefined : vm.maxHeight + 'px',
				minHeight: isNaN(vm.minHeight) ? '400px' : vm.minHeight + 'px',
			};
		};

		$scope.$watch('vm.items', function (newItems) {
			if (!Array.isArray(newItems) || newItems.length === 0) {
				vm.dataLoaded = false;
				return;
			}
			timelineItems = newItems;

			var items = new VisDataSet(
				newItems.map(function (object) {
					return {
						id: object[vm.idFieldName],
						content: object[vm.contentFieldName],
						start: object[vm.dateFieldName],
						title: object[vm.titleFieldName],
					};
				})
			);

			vm.timelineData = {
				items: items,
			};

			if (vm.dataLoaded) {
				vm.dataLoaded = false;
				$scope.$evalAsync(function () {
					vm.dataLoaded = true;
				});
			} else {
				vm.dataLoaded = true;
			}
		});
		return vm;
	}
})();
